import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  success: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    width: 'auto',
    flexDirection: 'row',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #4CAF50',
    height: 'auto',
    minHeight: '60px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '15px',
    lineHeight: '20.02px',
    color: '#2C2D3E',
    paddingRight: '8px',
    borderRadius: '4px',
    letterSpacing: '0.15px',
  },
  error: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    width: 'auto',
    flexDirection: 'row',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336',
    height: 'auto',
    minHeight: '60px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '15px',
    color: '#2C2D3E',
    paddingRight: '8px',
    borderRadius: '4px',
    lineHeight: '20px',
    letterSpacing: '0.15px',
  },
  iconSuccess: {
    color: '#347F42',

    marginTop: '6px',
    margin: '4px',
    padding: '8px',
  },
  iconError: {
    color: '#BC0000',
    marginTop: '5px',
    margin: '4px',
    padding: '8px',
  },
  iconClose: {
    color: 'rgba(44, 45, 62, 0.8)',
    padding: '6px',
  },
}));
